export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) return

  const user = useSupabaseUser()
  const supabase = useSupabaseClient()

  const publicRoutes = [
    '/gutter-cleaning-leads',
    '/gutter-cleaning-leads/',
    '/gutter-cleaning-leads/login',
    '/gutter-cleaning-leads/signup',
    '/gutter-cleaning-leads/pricing',
    '/gutter-cleaning-leads/terms',
    '/gutter-cleaning-leads/privacy-policy',
    '/gutter-cleaning-leads/accept-terms'
  ]

  if (publicRoutes.includes(to.path)) return

  const isProtectedLeadRoute = [
    '/gutter-cleaning-leads/leads',
    '/gutter-cleaning-leads/my-leads',
    '/gutter-cleaning-leads/dashboard',
    '/gutter-cleaning-leads/reactivate',
  ].some((path) => to.path === path || to.path.startsWith(`${path}/`))

  if (!isProtectedLeadRoute) return

  let userId = user.value?.id

  if (!userId) {
    const { data, error } = await supabase.auth.getUser()
    if (error || !data.user) {
      const redirect = encodeURIComponent(to.fullPath)
      return navigateTo(`/gutter-cleaning-leads/login?redirect=${redirect}`, { replace: true })
    }
    userId = data.user.id
  }

  const { data } = await supabase
    .from('contractor_profiles')
    .select('accepted_terms')
    .eq('id', userId)
    .maybeSingle()

  if (data?.accepted_terms !== true) {
    return navigateTo('/gutter-cleaning-leads/accept-terms')
  }
})
